const restoreStartupTokens = async ({
  getAccessTokenSilently,
  getIdTokenClaims,
}) => {
  let accessToken;
  try {
    accessToken = await getAccessTokenSilently();
  } catch (error) {
    // A signed-out visitor is an expected result of this optional startup check.
    if (error?.error === 'login_required') {
      return;
    }
    throw error;
  }

  const { __raw: idToken } = await getIdTokenClaims();
  window.localStorage.setItem('access_token', accessToken);
  window.localStorage.setItem('id_token', idToken);
  window.localStorage.setItem('auth_timestamp', new Date().getTime());
};

export default restoreStartupTokens;
